import {Injectable} from '@angular/core';
import {NestApiProvider} from '../nest-api';
import {Observable} from 'rxjs';
import {RequestEPFReportDto, ResponseEPFReportViewDto} from './epf-report.dto';

@Injectable()
export class EpfReportApi {
  private readonly service: string = 'payroll';
  private readonly model: string = 'epfreport';

  constructor(
      private nestApiProvider: NestApiProvider,
  ) {
  }

  public epfreportpdf(payload: RequestEPFReportDto): Observable<any> {
    const method: string = 'POST';
    const func: string = 'epfreportpdf';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.requestBlob<any>(method, url, params, urlParams, body);
  }

  public epfreportview(): Observable<ResponseEPFReportViewDto> {
    const method: string = 'GET';
    const func: string = 'epfreportview';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseEPFReportViewDto>(method, url, params, urlParams, body);
  }
}



// WEBPACK FOOTER //
// ./src/shared/nestjs/payroll/epf-report.api.ts